












































































































































import Vue from 'vue'
import mixins from 'vue-typed-mixins'

import UserManagementMixin from './UserManagementMixin'
import { UpdateProfile } from '@/queries/userProfile.graphql'
import { UpdateProfileMutation } from '@/graphql-schema'
import { AxiosInstance } from 'axios'
import AuthorizationMixin from '@/routing/AuthorizationMixin'


export default mixins(UserManagementMixin).extend({
  mixins: [AuthorizationMixin],
  computed: {
    currentUser() {
      return this.$store.getters.currentUser
    },
  },
  data() {
    const user = this.$store.getters.currentUser
    return {
      userData: {
        alias: user.alias,
        email: user.email,
      },
      passwordReset: {
        old_password: '',
        new_password: '',
        password_confirmation: '',
      },
    }
  },
  methods: {
    setupData() {
      this.resetValidation()

      const user = this.$store.getters.currentUser

      this.userData = {
        alias: user.alias,
        email: user.email,
      }

      this.passwordReset = {
        old_password: '',
        new_password: '',
        password_confirmation: '',
      }
    },
    changePassword() {
      const http: AxiosInstance = this.$store.getters.http
      http
        .post('/api/auth/users/change_password', {
          user: this.passwordReset,
        })
        .then(() => {
          return this.$store.dispatch({ type: 'loadUserProfile' })
        })
        .then(() => {
          this.setupData()
        })
        .catch(error => {
          if (error!.response!.data) {
            this.validation.errors = error.response.data
          } else {
            throw error
          }
        })
    },
    changeUserData() {
      const http: AxiosInstance = this.$store.getters.http
      let userDataWithLanguage = {
        alias: this.userData.alias,
        email: this.userData.email,
        language: this.$i18n.locale,
      }
      http
        .post('/api/auth/users/change_me', {
          user: userDataWithLanguage,
        })
        .then(() => {
          return this.$store.dispatch({ type: 'loadUserProfile' })
        })
        .then(() => {
          this.setupData()
        })
        .catch(error => {
          if (error!.response!.data) {
            this.validation.errors = error.response.data
          } else {
            throw error
          }
        })
    },
  },
})
